// extracted by mini-css-extract-plugin
export default {"statusBadge":"AffiliateStatusBadge_statusBadge__ZA6DB","statusActive":"AffiliateStatusBadge_statusActive__9li2u","statusDeactivated":"AffiliateStatusBadge_statusDeactivated__Uyisn"};